import store from "../../store";
import NProgress from 'nprogress';
import {grantAccessToContextApp} from "@/services/AuthService";
import {loadGrants} from "@dealer-group/dealerui";

export default async function ({next, router}) {

    if (
        !! store.state.Auth.token === false
        || store.state.context.continueUrl === null
    ) {
        return next();
    }

    await loadGrants();

    store.dispatch('Auth/fetchApplications')
        .then(() => {
            NProgress.set(0.8);
            return grantAccessToContextApp(router, next);
        })
        .catch(() => next())
}

